import { render } from "./GnLinkList.vue?vue&type=template&id=d666f066&scoped=true"
import script from "./GnLinkList.vue?vue&type=script&lang=js"
export * from "./GnLinkList.vue?vue&type=script&lang=js"

import "./GnLinkList.vue?vue&type=style&index=0&id=d666f066&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d666f066"]])

export default __exports__